






















import { Component, Prop, Vue } from 'vue-property-decorator';

  @Component
export default class UserAnonymity extends Vue {
    @Prop({ default: false }) readonly value!: boolean;

    selectedValue: string = this.value.toString();

    handleChange (value: boolean): void {
      this.selectedValue = value.toString();
      this.$emit('input', value);
    }
}
